import Button from "../../components/buttons/button";
import { FiAlertTriangle } from "react-icons/fi";

const DeleteMember = ({ t, selected, setOpen }) => {
  return (
    <div className="space-y-4">
      <span className="grid rounded-full w-11 mx-auto  size-11 place-content-center bg-[#FFEEEC]">
        <FiAlertTriangle size={28} className="text-[#FF0000]" />
      </span>
      <p className="text-xl font-bold text-center">{t("confirmDelete")}</p>
      <h3 className="font-bold text-center">{selected.fullName}</h3>
      <div className="font-medium text-center text-mainGray">
        <p>{t("permanentlyDeleteMember")}</p>
        <p>{t("cantBeReversed")}</p>
      </div>
      <div className="flex items-center justify-center gap-2">
        <Button
          className={"bg-[#902929]"}
          type={"button"}
          onClick={() => setOpen(false)}
        >
          {t("delete")}
        </Button>
        <Button className="mainLinear" onClick={() => setOpen(false)}>
          {t("cancel")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteMember;
